import { colors } from '@hydra/common/styles';
import { getCriteriaModules } from '@hydra/utils/reviewStructureHelper';
import { getPriSecColors } from '@hydra/utils/colors';

const WOORANK_LOGO = 'https://assets.woorank.com/assets/img/logo-big.png';

export const MAX_TEMPLATE_NAME_LENGTH = 200;

export const getInitialCustomCriteria = ({ modules, initialCustomCriteria = {} }) => {
  return modules.reduce(
    (customCriteria, { criteria }) => ({
      ...customCriteria,
      ...criteria.reduce(
        (arrayCustomCriteria, crit) => ({
          ...arrayCustomCriteria,
          [crit]: {
            enabled: true,
            customText: null,
            ...initialCustomCriteria[crit]
          }
        }),
        {}
      )
    }),
    {}
  );
};

export const generateEmptyTemplateData = ({
  name,
  language,
  keywordToolEnabled = true,
  closingPageEnabled = false,
  footerColor = colors.common.white
}) => {
  const { primary, secondary } = getPriSecColors();
  return {
    applyCustomCriteria: false,
    keywordTool: {
      enabled: keywordToolEnabled,
      displayChart: true,
      tableColumns: {
        location: true,
        volume: true,
        competitors: true
      },
      order: 'keyword',
      rankFilter: ''
    },
    trafficData: {},
    closingPage: {
      enabled: closingPageEnabled,
      customText: null
    },
    colorScheme: {
      primaryColor: [primary],
      secondaryColors: [...secondary],
      footerColor: [footerColor]
    },
    coverPage: null,
    customCriteria: getInitialCustomCriteria({ modules: getCriteriaModules() }),
    displayScore: true,
    externalLinks: true,
    footer: null,
    language: language || 'en',
    name: name || 'Default',
    theme: 'classic',
    orientation: 'portrait',
    shareWithSubusers: false,
    footerEnabled: true,
    introductionEnabled: true,
    tableOfContentEnabled: true,
    reviewDataEnabled: true,
    size: 'a4',
    rankedKeywords: {
      enabled: false,
      googleDomain: {
        country: 'us',
        language: 'en'
      },
      order: 'keyword_asc',
      rankFilter: '10'
    }
  };
};

export const generateEmptyTemplateDataForProUsers = ({ name, language }) => {
  return generateEmptyTemplateData({
    name,
    language,
    keywordToolEnabled: false,
    closingPageEnabled: true,
    footerColor: colors.grey.smoke
  });
};

export const getOverwrittenTemplateForProUser = (template) => {
  const { primary, secondary } = getPriSecColors();

  return {
    ...template,
    externalLinks: true,
    displayScore: true,
    footerEnabled: true,
    introductionEnabled: true,
    tableOfContentEnabled: true,
    logo: {
      uri: WOORANK_LOGO
    },
    footerLogo: {
      uri: WOORANK_LOGO
    },
    colorScheme: {
      primaryColor: [primary],
      secondaryColors: [...secondary],
      footerColor: [colors.grey.smoke]
    },
    keywordTool: {
      order: 'keyword',
      rankFilter: '',
      enabled: false,
      displayChart: true,
      tableColumns: {
        volume: true,
        location: true,
        competitors: true
      }
    },
    trafficData: {},
    footer: null,
    coverPage: null,
    closingPage: {
      enabled: true,
      customText: null
    },
    signature: null
  };
};
